export default __webpack_public_path__ + "static/media/target-size-icon.89e8c6fc.svg";